import { mapState, mapActions } from 'vuex';

import { useDataLoading } from '@mixins/factories';

import ColoredStateBadge from '@components/coloredStateBadge';
import OuterLink from '@components/outerLink';

import { generateReplacementStringFromObj } from '@modules/settings/replacements';

import JobProxyTest from '../../_components/jobProxyTest';
import JobLinksViewer from '../../_components/jobLinksViewer';
import JobDesignLinksViewer from '../../_components/JobDesignLinksViewer.vue';

const dataLoadingOptions = {
  getterName: 'getJob', searchable: false, paged: false, parameterize: true,
};

const jobHistoryHeaders = Object.assign([
  { text: 'Start Date', value: 'start' },
  { text: 'Operator', value: 'operator' },
  { text: 'State', value: 'state' },
  { text: 'Reason', value: 'reason' },
]);

export default {
  name: 'JobDetails',
  mixins: [
    useDataLoading(dataLoadingOptions),
  ],
  components: {
    ColoredStateBadge,
    OuterLink,
    JobProxyTest,
    JobLinksViewer,
    JobDesignLinksViewer,
  },
  data() {
    return {
      jobHistoryHeaders,
    };
  },
  computed: {
    ...mapState('jobs', ['job']),
    ...mapState('locations', ['suffix']),
    noJobLinks() {
      return !this.job.fileUrl && !this.job.frontUrl && !this.job.backUrl && !this.job.slipsheetUrl;
    },
    jobLinks() {
      return this.noJobLinks
        ? false
        : {
          fileUrl: this.job.fileUrl,
          frontUrl: this.job.frontUrl,
          backUrl: this.job.backUrl,
          slipsheetUrl: this.job.slipsheetUrl,
        };
    },
    jobHistory() {
      return this.job.history || [];
    },
    jobVendorData() {
      try {
        return JSON.stringify(JSON.parse(this.job.vendorData), null, '\t');
      } catch (e) {
        return '';
      }
    },
    formattedCode() {
      try {
        const data = JSON.parse(this.job.info);
        return JSON.stringify(data, null, '\t');
      } catch (e) {
        return '';
      }
    },
  },
  watch: {
    suffix(newValue) {
      this.$router.push({ name: 'jobs', query: { suffix: newValue, pageNum: '1' } });
    },
  },
  methods: {
    ...mapActions('jobs', ['getJob', 'syncJob']),
    syncJobById() {
      this.$VBlackerTheme.alert.warning({
        text: 'Sync job?',
      }, async () => {
        this.$VBlackerTheme.openLoadingSpinner();
        try {
          await this.syncJob({ id: this.$route.params.id });
          this.$VBlackerTheme.notification.success('Job synchronized');
          this.$_refreshData();
        } catch (e) {
          this.$VBlackerTheme.notification.error(e);
        } finally {
          this.$VBlackerTheme.closeLoadingSpinner();
        }
      });
    },
    getDimensions(w, h) {
      return w < h ? `${w}×${h}` : `${h}×${w}`;
    },

    generateReplacementStringFromObj,
  },
};
